import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Api, ApiError } from '../lib/api.js'
import { useAuth } from '../contexts/AuthContext.jsx'
import { env } from '../config/env.js'
import ProfileBar from '../components/review/ProfileBar.jsx'
import Button from '../components/ui/Button.jsx'

export default function ClientNewPage() {
  const { token, onUnauthorized } = useAuth()
  const nav = useNavigate()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [profile, setProfile] = useState({ civilStatus: 'marie', hasChildren: true, employment: 'salarie', ownership: 'proprietaire' })
  const [notes, setNotes] = useState('')
  const [err, setErr] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const onSubmit = async () => {
    setErr(null)
    if (!name.trim() || !email.trim()) {
      setErr('Nom et email requis')
      return
    }
    setSubmitting(true)
    const api = new Api({ baseURL: env.API_BASE_URL || '', getToken: () => token, onUnauthorized })
    try {
      const c = await api.createClient({
        name: name.trim(),
        email: email.trim(),
        phone: phone.trim(),
        civil_status: profile.civilStatus,
        has_children: profile.hasChildren,
        employment: profile.employment,
        ownership: profile.ownership,
        notes,
      })
      nav(`/clients/${c.ID || c.id}`)
    } catch (e) {
      if (e instanceof ApiError && e.status === 409) {
        setErr('Un client avec cet email existe déjà')
      } else {
        setErr(e.message)
      }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="max-w-[680px] px-4 py-6 sm:px-7 sm:py-8 md:px-12 lg:px-20">
      <h1 className="mb-6 text-[22px] font-semibold tracking-[-0.02em]">Nouveau client</h1>
      <div className="space-y-4">
        <label className="block">
          <span className="text-[12px] text-muted">Nom</span>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="mt-1 w-full rounded-lg border border-line bg-white px-3 py-2.5 text-[15px] sm:py-2 sm:text-[14px]" />
        </label>
        <label className="block">
          <span className="text-[12px] text-muted">Email</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-lg border border-line bg-white px-3 py-2.5 text-[15px] sm:py-2 sm:text-[14px]" />
        </label>
        <label className="block">
          <span className="text-[12px] text-muted">Téléphone</span>
          <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} className="mt-1 w-full rounded-lg border border-line bg-white px-3 py-2.5 text-[15px] sm:py-2 sm:text-[14px]" />
        </label>
        <div>
          <span className="text-[12px] text-muted">Profil</span>
          <div className="mt-1"><ProfileBar profile={profile} onChange={setProfile} /></div>
        </div>
        <label className="block">
          <span className="text-[12px] text-muted">Notes</span>
          <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={4} className="mt-1 w-full rounded-lg border border-line bg-white px-3 py-2.5 text-[15px] sm:py-2 sm:text-[14px]" />
        </label>
        {err && <div className="rounded-lg border border-terra-500/40 bg-terra-50 px-4 py-3 text-[12.5px] text-terra-600">{err}</div>}
        <div className="flex justify-end">
          <Button size="lg" disabled={submitting} onClick={onSubmit}>Créer</Button>
        </div>
      </div>
    </div>
  )
}
